import UserPersistence from "../../../persistence/UserPersistence";

export const moduleId = "user";

export const state = {
  get userBaseInfo(){
    return UserPersistence.getBaseInfo().user
  },
  get menuList() {
    return UserPersistence.getBaseInfo().menuList || []
  },
  accountingStandard: 230
};

export const actions = {};

export const mutations = {
  setAccountingStandard(state, value){
    state.accountingStandard = value;
  }
};




// WEBPACK FOOTER //
// ./src/store/modules/user/index.js